import { isAnyOf } from '@reduxjs/toolkit';
import { createGenericSlice } from '../genericSlice.js';
import { getCartItemsAmount, addProduct, removeItem, getCart, updateItemQuantity } from './thunks.js';
import initialState from './initialState.js';
import 'lodash/set';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import '../../modal-6vnX5SO3.js';
import 'lodash/get';
import '../../services/graphql/cart/index.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../requestsCollection-_VRM28HJ.js';
import '../../graphqlRequestClient-3KYHZKVm.js';
import 'react';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/logToSlack.js';
import '../../utils/cookies.js';
import 'cookies-next';
import '../../cookies-l-jEMp6P.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import '../../utils/isBot.js';
import '../../utils/currency.js';
import '../../context/index.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import 'next/router';
import '../../helpers-kA_hdoOI.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import 'lodash';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/cart.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-Vtx0Wqgk.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/error.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/salesforce.js';
import '../../cart-SVV9q5Ln.js';
import '../../selectItem-PWuzvZX7.js';
import '../../cart-bEN0otWy.js';

const cartSlice = createGenericSlice({
    name: 'cart',
    initialState,
    reducers: {
        setPrices: (state, action) => {
            state.prices = action.payload;
        },
        resetCart: () => initialState,
    },
    extraReducers: builder => {
        builder.addCase(getCartItemsAmount.fulfilled, (state, { payload }) => {
            state.total_quantity = payload;
        });
        builder.addCase(addProduct.fulfilled, (state, { payload }) => {
            state.total_quantity = payload.total_quantity;
        });
        builder.addCase(removeItem.fulfilled, (state, { payload }) => {
            // Using a special condition here to fix and issue with parallel item remove requests
            // === Steps to reproduce:
            // 1. Add 2 items into the ShoppingCart
            // 2. Click on Remove Item#1 (Request#1) and then immediately click on remove Item#2 (Request#2)
            // === Observed behavior:
            // 1. The Request#2 response may come first and Request#1 response may come last
            // 2. The Request#1 response will contain 1 item (Item#2); the Request#2 response will contain 0 items
            // 3. In this case a Request#1 response will be used in the cart store
            // 4. And a ShoppingCart will display incorrect data: Item#2 will be present instead of showing an empty cart
            // === Expected behavior:
            // Request#2 response should be applied to the cart store
            // Next condition fixes this issue
            if (state.items.length < payload.items.length)
                return;
            state.total_quantity = payload.total_quantity;
            state.available_promo_label = payload.available_promo_label;
            state.total_quantity = payload.total_quantity;
            state.items = payload.items;
            state.prices = payload.prices;
            state.has_fetched = true;
        });
        builder.addMatcher(isAnyOf(getCart.fulfilled, updateItemQuantity.fulfilled), (state, { payload }) => {
            state.available_promo_label = payload.available_promo_label;
            state.total_quantity = payload.total_quantity;
            state.items = payload.items;
            state.prices = payload.prices;
            state.has_fetched = true;
        });
        builder.addMatcher(isAnyOf(getCart.pending, updateItemQuantity.pending, removeItem.pending), state => {
            state.has_fetched = false;
        });
    },
});
const { setPrices, resetCart } = cartSlice.actions;
var index = cartSlice.reducer;

export { index as default, resetCart, setPrices };
//# sourceMappingURL=index.js.map
